module.exports = __webpack_public_path__ + "img/ywAward-1.69493120.png";